import React from 'react';
import { Link } from 'react-router-dom';
import { products } from '../data/products';
import { isExcelAfterDark, siteConfig } from '../config/site';

export const Products = () => (
  <div className="min-h-screen bg-gray-50 py-12">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-2">{isExcelAfterDark ? 'After-dark creations' : 'Excel Add-ins'}</h1>
      {isExcelAfterDark && <p className="text-gray-600 mb-8">Original Excel tools for people who want their spreadsheets to do something unexpected.</p>}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {Object.values(products).filter((product) => !isExcelAfterDark || product.slug === 'excel-colour-picker').map((product) => (
          <Link
            key={product.slug}
            to={`/products/${product.slug}`}
            className="bg-white rounded-xl shadow-sm overflow-hidden hover:shadow-md transition-shadow no-underline"
          >
            <img src={product.image} alt={product.title} className="w-full h-48 object-cover" />
            <div className="p-6">
              <h3 className="text-xl font-semibold mb-2 text-gray-900">{product.title}</h3>
              <p className="text-gray-600 mb-4">{product.description}</p>
              <div className="flex justify-between items-center">
                <span className={`text-2xl font-bold ${siteConfig.theme.accentText}`}>{product.price}</span>
                <span className={`${siteConfig.theme.button} text-white px-4 py-2 rounded-lg`}>
                  Learn More
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  </div>
);
